module.exports = __webpack_public_path__ + "static/img/build4.54c2302a.png";